import { render } from "./AutocompleteMultiple.vue?vue&type=template&id=a071397c"
import script from "./AutocompleteMultiple.vue?vue&type=script&lang=js"
export * from "./AutocompleteMultiple.vue?vue&type=script&lang=js"

import "./AutocompleteMultiple.vue?vue&type=style&index=0&id=a071397c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__